var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"mainApp"},[_c('Header'),_c('v-main',{staticStyle:{"padding-top":"0px !important","margin-bottom":"50px"}},[_c('v-container',[_c('router-view')],1)],1),(_vm.isopenCookies)?_c('Cookies',{on:{"getOpen":_vm.openCookies,"setState":_vm.setStates}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }